// extracted by mini-css-extract-plugin
export default {"contactTabs":"ClientsContactWindow_contactTabs__Zcgih","customTabBtns":"ClientsContactWindow_customTabBtns__cVCOW","disablesBtn":"ClientsContactWindow_disablesBtn__stOSa"};